import React from "react";
import { useTranslation } from "react-i18next";
import {
  FormControlLabel,
  Checkbox,
  TextField,
} from "@mui/material";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import "./OffTableCoachToolsEditor.css";

/**
 * Planning toggles for off-table coach tools (chrono + count drills).
 */
export function OffTableCoachToolsEditor({ value, onChange, disabled = false }) {
  const { t } = useTranslation();
  const tools = value || { chrono: true, count: false, count_label: "" };

  const patch = (partial) => {
    onChange?.({
      chrono: Boolean(tools.chrono),
      count: Boolean(tools.count),
      count_label: tools.count_label || "",
      ...partial,
    });
  };

  return (
    <div className="ot-coach-tools">
      <p className="ot-coach-tools__hint">
        {t("planningOffTableToolsHint") ||
          "Enable Live Training tools for this off-table block. Chrono times athletes; Count tracks reps (push-ups, racket bounces, …)."}
      </p>
      <div className="ot-coach-tools__row">
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(tools.chrono)}
              disabled={disabled}
              onChange={(e) => patch({ chrono: e.target.checked })}
              color="primary"
            />
          }
          label={
            <span className="ot-coach-tools__label">
              <TimerOutlinedIcon fontSize="small" />
              {t("planningOffTableToolChrono") || "Chronometer"}
            </span>
          }
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(tools.count)}
              disabled={disabled}
              onChange={(e) => patch({ count: e.target.checked })}
              color="primary"
            />
          }
          label={
            <span className="ot-coach-tools__label">
              <FormatListNumberedIcon fontSize="small" />
              {t("planningOffTableToolCount") || "Counting drills"}
            </span>
          }
        />
      </div>
      {tools.count ? (
        <TextField
          size="small"
          fullWidth
          disabled={disabled}
          label={t("planningOffTableCountLabel") || "What to count"}
          placeholder={
            t("planningOffTableCountPlaceholder") ||
            "e.g. Push-ups, ball bounces on racket"
          }
          value={tools.count_label || ""}
          onChange={(e) => patch({ count_label: e.target.value })}
          inputProps={{ maxLength: 80 }}
        />
      ) : null}
    </div>
  );
}

export default OffTableCoachToolsEditor;
